import * as actionTypes from "./actionTypes";

export const setSpecialOfferDetailAction = params => ({
	type: actionTypes.SET_SPECIAL_OFFER_DETAIL_ACTION,
	params
});

export const setGiftExchangeDetailAction = params => ({
	type: actionTypes.SET_GIFT_EXCHANGE_DETAIL_ACTION,
	params
});

export const setPromotionDetailAction = params => ({
	type: actionTypes.SET_PROMOTION_DETAIL_ACTION,
	params
});
